module.exports = __webpack_public_path__ + "img/staff_man.683d6a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_man.png
// module id = wUx7
// module chunks = 1